import $ from 'jquery';

export const elements = {
    call: '.js-HiddenBox-Call',
    holder: '.js-HiddenBox-Holder',
    box: '.js-HiddenBox-Box',
};

export const toggleHiddenBox = ($call, $box) => {
    $call.toggleClass('fn-active');

    if ($call.hasClass('fn-active')) {
        $box.addClass('fn-visible');
    } else {
        const $input = $box.find('input');

        $input.attr('readonly', 'readonly');
        setTimeout(function() {
            $input.blur();
            $input.removeAttr('readonly');
        }, 100);

        $box.removeClass('fn-visible');
    }
};

export const onCallClick = function () {
    const $this = $(this);
    const $holder = $this.parents(elements.holder);
    const $box = $holder.find(elements.box);

    toggleHiddenBox($holder, $box);
};

export const onDocumentClick = function ($body, e) {
    const $target = $(e.target);

    if (!$target.hasClass(elements.call) && !$target.parents().hasClass(elements.box)) {
        const $activeCall = $body.find(`${elements.call}.fn-active`);
        const $activeBox = $activeCall.parents(elements.holder).find(elements.box);

        $activeCall.removeClass('fn-active');
        $activeBox.removeClass('fn-visible');
    }
};

export default {
    init(params) {
        const { $document, $body } = params;

        $document.on('click', elements.call, onCallClick);
        $document.on('click', $.proxy(onDocumentClick, null, $body));
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/hidden-box.js